export default __webpack_public_path__ + "static/media/everybyte.5b46e9bc.png";